// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/fulfillment/pick_pack/v1/packing.proto (package stailer_service_specification.fulfillment.pick_pack.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { enumDesc, fileDesc, messageDesc, tsEnum } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_enum_description } = require("../../../../description_support/v1/enum_description_pb");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/fulfillment/pick_pack/v1/packing.proto.
 */
const file_stailer_service_specification_fulfillment_pick_pack_v1_packing = /*@__PURE__*/
  fileDesc("CkRzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9mdWxmaWxsbWVudC9waWNrX3BhY2svdjEvcGFja2luZy5wcm90bxI2c3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24uZnVsZmlsbG1lbnQucGlja19wYWNrLnYxIvUFCgdQYWNraW5nEvUBChRjb250YWluZXJfbGFiZWxfc2l6ZRgEIAEoDjJSLnN0YWlsZXJfc2VydmljZV9zcGVjaWZpY2F0aW9uLmZ1bGZpbGxtZW50LnBpY2tfcGFjay52MS5QYWNraW5nLkNvbnRhaW5lckxhYmVsU2l6ZUKCAZKCGVTjg5Hjg4Pjgq3jg7PjgrDmmYLjgavkvb/jgYbjgrPjg7Pjg4bjg4rjgavosrzjgovjg6njg5njg6vjgrXjgqTjgrrjga7mjIflrprjgafjgZnjgIKgghkBqoIZHuOCs+ODs+ODhuODiuODqeODmeODq+OCteOCpOOCusiCGQES8wEKFnN0YWZmX2FwcF9wYWNraW5nX2xpc3QYBSABKAsySy5zdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5mdWxmaWxsbWVudC5waWNrX3BhY2sudjEuU3RhZmZBcHBQYWNraW5nTGlzdEKFAZKCGULjgrnjgr/jg4Pjg5XjgqLjg5fjg6rjga7jg5Hjg4Pjgq3jg7PjgrDjg6rjgrnjg4jjga7ku5Xmp5jjgafjgZnjgIKgghkBqoIZM+OCueOCv+ODg+ODleOCouODl+ODquODkeODg+OCreODs+OCsOODquOCueODiOS7leanmMiCGQEi+wEKEkNvbnRhaW5lckxhYmVsU2l6ZRJkCiBDT05UQUlORVJfTEFCRUxfU0laRV9VTlNQRUNJRklFRBAAGj7qghkt5pyq6Kit5a6a44Gu5aC05ZCI44GvOlRPRE8644Gr44Gq44KK44G+44GZ44CC+oIZCeacquaMh+WumhJ/ChpDT05UQUlORVJfTEFCRUxfU0laRV9TTUFMTBABGl/qghlL5bCP44GV44GE44Op44OZ44Or44K144Kk44K644Gn44GZ44CC5YW35L2T55qE44Gr44GvOlRPRE8644Gr44Gq44KK44G+44GZ44CC+oIZDOWwj+OCteOCpOOCuiLhAQoTU3RhZmZBcHBQYWNraW5nTGlzdBLJAQoeZW5hYmxlX2Rpc3BsYXlpbmdfcHJvZHVjdF9jb2RlGAIgASgIQqABkoIZaOOCueOCv+ODg+ODleOCouODl+ODquOBruODkeODg+OCreODs+OCsOODquOCueODiOOBq1Byb2R1Y3RDb2Rl44KS6KGo56S644GZ44KL5aC05ZCI44Gr5oyH5a6a44GX44G+44GZ44CCqoIZLOOCueOCv+ODg+ODleOCouODl+ODquOBq1Byb2R1Y3RDb2Rl44KS6KGo56S6yIIZAWIGcHJvdG8z", [file_description_support_v1_enum_description, file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.fulfillment.pick_pack.v1.Packing.
 * Use `create(PackingSchema)` to create a new message.
 */
const PackingSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_fulfillment_pick_pack_v1_packing, 0);

/**
 * Describes the enum stailer_service_specification.fulfillment.pick_pack.v1.Packing.ContainerLabelSize.
 */
const Packing_ContainerLabelSizeSchema = /*@__PURE__*/
  enumDesc(file_stailer_service_specification_fulfillment_pick_pack_v1_packing, 0, 0);

/**
 * パッキング時に使うコンテナに貼るラベルサイズの指定です。
 *
 * @generated from enum stailer_service_specification.fulfillment.pick_pack.v1.Packing.ContainerLabelSize
 */
const Packing_ContainerLabelSize = /*@__PURE__*/
  tsEnum(Packing_ContainerLabelSizeSchema);

/**
 * Describes the message stailer_service_specification.fulfillment.pick_pack.v1.StaffAppPackingList.
 * Use `create(StaffAppPackingListSchema)` to create a new message.
 */
const StaffAppPackingListSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_fulfillment_pick_pack_v1_packing, 1);


exports.file_stailer_service_specification_fulfillment_pick_pack_v1_packing = file_stailer_service_specification_fulfillment_pick_pack_v1_packing;
exports.PackingSchema = PackingSchema;
exports.Packing_ContainerLabelSizeSchema = Packing_ContainerLabelSizeSchema;
exports.Packing_ContainerLabelSize = Packing_ContainerLabelSize;
exports.StaffAppPackingListSchema = StaffAppPackingListSchema;
